import React from 'react';
import { withStyles } from "@mui/styles";

const styles = (theme) => ({
  floatingParticles: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
    pointerEvents: 'none',
    '&::before, &::after, & .particle1, & .particle2, & .particle3, & .particle4, & .particle5, & .particle6, & .particle7, & .particle8, & .particle9, & .particle10': {
      content: '""',
      position: 'absolute',
      width: '4px',
      height: '4px',
      background: 'rgba(232, 163, 61, 0.6)',
      animation: '$particleFloat 12s linear infinite',
      borderRadius: '50%',
      opacity: 0,
    },
    '&::before': {
      left: '10%',
      top: '20%',
      animationDelay: '0s',
    },
    '&::after': {
      right: '15%',
      bottom: '30%',
      animationDelay: '4s',
    },
    '& .particle1': {
      left: '25%',
      top: '15%',
      animationDelay: '1s',
      width: '3px',
      height: '3px',
    },
    '& .particle2': {
      left: '75%',
      top: '25%',
      animationDelay: '2s',
      width: '5px',
      height: '5px',
    },
    '& .particle3': {
      left: '45%',
      top: '70%',
      animationDelay: '3s',
      width: '2px',
      height: '2px',
    },
    '& .particle4': {
      left: '85%',
      top: '60%',
      animationDelay: '5s',
      width: '4px',
      height: '4px',
    },
    '& .particle5': {
      left: '5%',
      top: '80%',
      animationDelay: '6s',
      width: '3px',
      height: '3px',
    },
    '& .particle6': {
      left: '60%',
      top: '10%',
      animationDelay: '7s',
      width: '6px',
      height: '6px',
    },
    '& .particle7': {
      left: '30%',
      top: '40%',
      animationDelay: '8s',
      width: '4px',
      height: '4px',
    },
    '& .particle8': {
      left: '70%',
      top: '50%',
      animationDelay: '9s',
      width: '5px',
      height: '5px',
    },
    '& .particle9': {
      left: '20%',
      top: '60%',
      animationDelay: '10s',
      width: '3px',
      height: '3px',
    },
    '& .particle10': {
      left: '80%',
      top: '70%',
      animationDelay: '11s',
      width: '4px',
      height: '4px',
    },
  },
  '@keyframes particleFloat': {
    '0%': {
      transform: 'translateY(0px) translateX(0px)',
      opacity: 0,
    },
    '10%': {
      opacity: 0.5,
    },
    '90%': {
      opacity: 0.5,
    },
    '100%': {
      transform: 'translateY(-100px) translateX(20px)',
      opacity: 0,
    },
  },
});

function LobbyParticles({ classes }) {
  return (
    <div className={classes.floatingParticles}>
      <div className="particle1"></div>
      <div className="particle2"></div>
      <div className="particle3"></div>
      <div className="particle4"></div>
      <div className="particle5"></div>
      <div className="particle6"></div>
      <div className="particle7"></div>
      <div className="particle8"></div>
      <div className="particle9"></div>
      <div className="particle10"></div>
    </div>
  );
}

export default withStyles(styles)(LobbyParticles);